import React from 'react';
import LzXBaseField from '../BaseField/BaseField';
import InputLabel from '@mui/material/InputLabel';
import Grid from '@mui/material/Grid';

import './StaticField.scss';

export interface LzPStatic {
  fluid?: boolean;
  alignRight?: boolean;
  icon?: React.ReactNode;
  className?: string;
  label?: string;
  value?: string;
  variant?: string;
  style?: React.CSSProperties;
  compact?: boolean;
  disabled?: boolean;
  isReactNode?: boolean;
}

const LzXStaticField = (props: LzPStatic) => {
  const styles: any = props.style || {};
  if (props.alignRight) {
    styles.textAlign = 'right';
  }

  if ('horizontal' === props.variant) {
    return (
      <Grid container spacing={0}>
        <Grid size={{ xs: 6 }}>
          <InputLabel>
            {props.icon && <React.Fragment>{props.icon} </React.Fragment>}
            {props.label}
          </InputLabel>
        </Grid>
        <Grid size={{ xs: 6 }}>
          {props.isReactNode ? (
            <React.Fragment>{props.value}</React.Fragment>
          ) : (
            <p
              className={'lz-static ' + (props.className || '')}
              style={styles}
              dangerouslySetInnerHTML={{ __html: props.value || '' }}
            ></p>
          )}
        </Grid>
      </Grid>
    );
  }

  return (
    <LzXBaseField
      labelShrink
      fluid={props.fluid}
      icon={props.icon}
      label={props.label}
    >
      {props.isReactNode ? (
        <React.Fragment>{props.value}</React.Fragment>
      ) : (
        <p
          className={
            'lz-static ' +
            (props.compact ? 'lz-compact ' : '') +
            (props.className || '')
          }
          style={styles}
          dangerouslySetInnerHTML={{ __html: props.value || '' }}
        ></p>
      )}
    </LzXBaseField>
  );
};

export default LzXStaticField;
